module.exports = __webpack_public_path__ + "media/customizations/regencyatoldetowne/logo-4f631b95ca3b47303f7a219f08e6f5ff.png";